import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Mutations from '@api/graphql/mutations';
import { createProductCategoryVariables } from '@api/graphql/types';
import ProductCategoryForm from '../components/ProductCategoryForm';

type Props = {
} & InjectedIntlProps & RouteComponentProps;


interface State {
    formData: createProductCategoryVariables;
}

class ProductCategoryCreate extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            formData: {
                name: '',
                parent_id: null,
                url_key: '',
                content: null,
                is_enable: true,
                date_to: null,
                date_from: null,
                show_in_menu: true,
                keywords: null,
                description: null,
                is_promotion: false,
                is_homepage_prohibited: false,
                promotion_place: null,
            },
        };
    }

    public onSubmit = (variables: createProductCategoryVariables) => {
        return GraphQLClient.mutate({
            mutation: Mutations.createProductCategory, variables,
        });
    }

    public render() {
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">
                        <div className="ibox-title">
                            <h5>{this.props.intl.formatMessage({ id: 'module.productCategory.create.title'})}</h5>
                        </div>
                        <div className="ibox-content">
                            {this.state.formData &&
                                <ProductCategoryForm formData={this.state.formData} onSubmit={this.onSubmit}/>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default compose(
    injectIntl,
    withRouter,
)(ProductCategoryCreate);



// WEBPACK FOOTER //
// ./src/modules/ProductCategory/pages/ProductCategoryCreate.tsx